<template>
  <div class="applyInfo">
    <table-list
      title="报名资料"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="examPlanList"
      :btns="btns(this)"
      :footer-btns="footerBtns(this)"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :options="{ selection: true, operatesWidth: 100 }"
      :span-method="objectSpanMethod"
      :row-class-name="rowClass"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <ImportFileUser ref="ImportFileUser" @success="getExamPlanList"></ImportFileUser>
    <AddUser ref="AddUser" @success="getExamPlanList"></AddUser>
    <Appendix ref="Appendix"></Appendix>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '信息同步',
    icon: 'el-icon-refresh',
    method: _this.handleInfoUpdata,
    loading: _this.importLoading,
  },
  {
    label: '导入考生',
    icon: 'el-icon-circle-plus-outline',
    method: _this.handleImportUser,
    isShow: !_this.isSuper,
  },
  {
    label: '添加',
    icon: 'el-icon-circle-plus-outline',
    method: _this.handleAdd,
    isShow: !_this.isSuper,
  },
]
// 底部按钮
const footerBtns = _this => [
  {
    label: '导出全部',
    icon: 'el-icon-download',
    method: _this.exportTable,
  },
  {
    label: '删除',
    method: _this.handleBacthDelete,
    type: 'danger',
    isShow: !_this.isSuper,
  },
]
// 搜索框配置
const searchForm = _this => [
  {
    label: '姓名/手机/身份证号',
    prop: 'userFilter',
  },
  {
    label: '公司名称',
    prop: 'company',
  },
  {
    label: '业务员',
    prop: 'salesman',
  },
  {
    label: '渠道',
    prop: 'channel',
  },
  {
    label: '创建人',
    prop: 'creatorName',
  },
  {
    placeholder: '证书名称-级别',
    type: 'treeAllSelect',
    width: 120,
    prop: 'certifiterMap',
    options: _this.certifiterList,
    optionProps: {
      checkStrictly: true,
      value: 'jobId',
      label: 'jobName',
      children: 'levelList',
    },
  },
  {
    type: 'daypicker',
    placeholder: '报考时间',
    prop: 'applicationTime',
  },
  {
    placeholder: '创建时间',
    type: 'daypicker',
    prop: 'createTime',
  },
  {
    placeholder: '状态',
    type: 'select',
    prop: 'state',
    children: [
      { value: 1, label: '未安排' },
      { value: 2, label: '已考试' },
    ],
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'serialNumber',
    label: '序号',
    minWidth: 60,
  },
  {
    prop: 'name',
    label: '姓名',
    minWidth: 80,
    twoLines: true,
    render: (h, { row }) => {
      return [
        h(
          'el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                _this.handleEdit(row)
              },
            },
          },
          row.name,
        ),
      ]
    },
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 120,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 170,
    twoLines: true,
  },
  {
    prop: 'company',
    label: '公司名称',
    minWidth: 170,
  },
  {
    prop: 'jobName',
    label: '报考证书名称',
    minWidth: 180,
  },
  {
    prop: 'jobLevel',
    label: '级别',
    minWidth: 50,
  },
  {
    label: '报考时间',
    minWidth: 100,
    prop: 'applicationTime',
  },
  {
    prop: 'money',
    label: '金额',
    minWidth: 100,
    align: 'right',
  },
  {
    prop: 'channel',
    label: '渠道',
    minWidth: 170,
  },
  {
    prop: 'stateValue',
    label: '状态',
    minWidth: 100,
  },
  {
    prop: 'salesman',
    label: '业务员',
    minWidth: 80,
  },
  {
    prop: 'creatorName',
    label: '创建人',
    minWidth: 80,
  },
  {
    prop: 'createTime',
    label: '导入时间',
    minWidth: 160,
    sortdata: 1,
  },
  {
    label: '附件',
    minWidth: 100,
    fixed: 'right',
    render: (h, { row }) => {
      return [
        h(
          'el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                _this.handleRead(row)
              },
            },
          },
          '查看' + '(' + row.fileNum + ')',
        ),
      ]
    },
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleEdit,
    label: '编辑',
    isShow: () => _this.isSuper,
  },
]
import TableList from '@/components/TableList'
import { filterJobLevel } from '@/api/exam'
import { userIsSuper } from '@/api/login'
import { applyInfoPage, applyPageExport, applyPageDelete, infoUpdate } from '@/api/apply'
import to from 'await-to'
import ImportFileUser from './components/importDialog'
import AddUser from './components/addUserDialog'
import Appendix from './components/appenDix'
export default {
  name: 'ExamItems',
  components: {
    TableList,
    ImportFileUser,
    AddUser,
    Appendix,
  },
  data() {
    return {
      searchForm,
      btns,
      footerBtns,
      columns,
      operates,
      loading: false,
      examPlanList: [],
      selectList: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      queryParams: {},
      mergeIDList: [],
      certifiterList: [],
      isSuper: false,
      importLoading: false,
    }
  },
  mounted() {
    this.handleIsSuper()
    this.getJobLevel()
    this.getExamPlanList()
  },
  methods: {
    async handleInfoUpdata() {
      this.importLoading = true
      const [, err] = await to(infoUpdate({}))
      this.importLoading = false
      if (err) return this.$message.warning(err.msg)
      this.getExamPlanList()
    },
    async handleIsSuper() {
      const [res, err] = await to(userIsSuper({}))
      if (err) return this.$message.warning(err.msg)
      this.isSuper = res.data
    },
    async getJobLevel() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.certifiterList = res.data
    },
    async getExamPlanList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(applyInfoPage({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.examPlanList = res.data.list
      this.pager.total = res.data.total
      this.examPlanList.forEach(element => {
        this.$set(element, 'fileNum', 0)
        if (element.appendixList && element.appendixList.length) {
          element.fileNum = element.appendixList.length
        }
      })
      this.mergeData()
    },
    //导出
    async exportTable() {
      let nowTime = new Date()
      let nowYear = nowTime.getFullYear()
      let nowMonth = nowTime.getMonth() + 1
      let nowDay = nowTime.getDate()
      let nowHours = nowTime.getHours()
      let nowMinutes = nowTime.getMinutes()
      let nowSeconds = nowTime.getSeconds()
      let downLoadTime =
        nowYear +
        '-' +
        nowMonth +
        '-' +
        nowDay +
        ' ' +
        nowHours +
        '：' +
        nowMinutes +
        '：' +
        nowSeconds
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let arr = []
      if (this.selectList.length) this.selectList.map(v => arr.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        applyPageExport({
          current,
          size,
          idList: arr,
          ...this.queryParams,
        }),
      )
      loading.close()
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '报名资料（' + downLoadTime + '）' + '.zip'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    // 查询按钮
    onSearch(queryParams) {
      if (queryParams.certifiterMap && queryParams.certifiterMap.length) {
        if (queryParams.certifiterMap.length == 1) {
          queryParams.jobId = String(queryParams.certifiterMap[0])
          queryParams.jobLevel = ''
        } else if (queryParams.certifiterMap.length > 1) {
          queryParams.jobId = String(queryParams.certifiterMap[0])
          queryParams.jobLevel = String(
            queryParams.certifiterMap[queryParams.certifiterMap.length - 1],
          )
        } else {
          queryParams.jobId = ''
          queryParams.jobLevel = ''
        }
      } else {
        queryParams.jobId = ''
        queryParams.jobLevel = ''
      }
      if (queryParams.applicationTime && queryParams.applicationTime.length) {
        queryParams.applicationStartTime = queryParams.applicationTime[0]
        queryParams.applicationEndTime = queryParams.applicationTime[1]
      } else {
        queryParams.applicationStartTime = ''
        queryParams.applicationEndTime = ''
      }
      if (queryParams.createTime && queryParams.createTime.length) {
        queryParams.createStartTime = queryParams.createTime[0]
        queryParams.createEndTime = queryParams.createTime[1]
      } else {
        queryParams.createStartTime = ''
        queryParams.createEndTime = ''
      }
      this.pager.current = 1
      this.queryParams = queryParams
      this.getExamPlanList()
    },
    // 编辑
    handleEdit(row) {
      // this.$refs.AddUser.show(row.id)
      this.$router.push({ path: '/apply/list/add', query: { id: row.id } })
    },
    // 删除
    async handleBacthDelete() {
      let arr = []
      if (this.selectList.length == 0) return this.$message.warning('请选择要删除的资料')
      this.selectList.map(v => arr.push(v.id))
      this.$confirm(`您确定要删除吗？删除后将无法恢复`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(applyPageDelete({ idList: arr }))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          this.getExamPlanList()
        })
        .catch(() => {})
    },
    async handleAdd() {
      // this.$refs.AddUser.show()
      this.$router.push({ path: '/apply/list/add' })
    },
    handleImportUser() {
      this.$refs.ImportFileUser.show()
    },
    handleRead(row) {
      this.$refs.Appendix.show(row)
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getExamPlanList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getExamPlanList()
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    mergeData() {
      this.mergeIDList = []
      let i = 0
      this.examPlanList.forEach((item, index) => {
        if (index === 0) {
          // 第一行必须存在
          this.mergeIDList.push(1)
          i = 0
        } else {
          if (item.id === this.examPlanList[index - 1].id) {
            this.mergeIDList[i]++
            this.mergeIDList.push(0)
          } else {
            this.mergeIDList.push(1)
            i = index
          }
        }
      })
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      const MergeColIndex = [0, 1, 2, 11, 12, 13, 14] // 全部合并的一级列
      if (MergeColIndex.includes(columnIndex)) {
        const colNum = this.mergeIDList[rowIndex]
        return {
          rowspan: colNum, // n行单元格的第一个直接占满n行
          colspan: colNum > 0 ? 1 : 0,
        }
      }
    },
    rowClass({ rowIndex }) {
      var classList = []
      let i = 0
      this.examPlanList.forEach((item, index) => {
        if (index === 0) {
          classList.push('odd-row')
          i = 0
        } else {
          if (item.id === this.examPlanList[index - 1].id) {
            classList.push(classList[i])
          } else {
            if (classList[i] == 'odd-row') {
              classList.push('even-row')
            } else {
              classList.push('odd-row')
            }
            i = index
          }
        }
      })
      return classList[rowIndex]
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-table {
  .even-row {
    background-color: #fff;
  }
  .odd-row {
    .el-table__cell {
      background-color: #fafafa !important;
    }
  }
  .red {
    color: #ed5327;
  }
}
.applyInfo {
  ::v-deep .table-list {
    .form {
      .el-cascader .el-input,
      .el-input .el-select {
        width: 250px !important;
        .el-input__inner {
          width: 250px !important;
        }
      }
      .el-date-editor {
        width: 250px !important;
      }
    }
  }
}
</style>
